import { useEffect } from "react";
import { GetUserRequest } from "../services/soap/access/requests/GetUserRequest";

interface UseMessageNodeIdProps {
  store: any;
  accessService: any;
  setMessageNodeId: (nodeId: number) => void;
  dependencies?: any[];
}

/**
 * Custom hook to handle messageNodeId initialization from user data
 */
export function useMessageNodeId({
  store,
  accessService,
  setMessageNodeId,
  dependencies = [],
}: UseMessageNodeIdProps) {
  useEffect(() => {
    (async () => {
      try {
        const userResp = await accessService.getUser(
          new GetUserRequest(
            store.Server,
            store.SessionId,
            store.UserId.toString()
          )
        );

        if (userResp?.USER?.messageNode) {
          setMessageNodeId(userResp.USER.messageNode);
        } else {
          setMessageNodeId(0);
        }
      } catch (error) {
        console.error("Error fetching user message node:", error);
        setMessageNodeId(0);
      }
    })();
  }, [...dependencies]);
}
